import { useTheme, type ThemePreference } from "../theme/ThemeProvider";

const OPTIONS: { value: ThemePreference; label: string; icon: string }[] = [
  { value: "light", label: "Light", icon: "☀️" },
  { value: "system", label: "System", icon: "🖥️" },
  { value: "dark", label: "Dark", icon: "🌙" },
];

export function ThemeToggle() {
  const { preference, setPreference } = useTheme();
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5 dark:border-night-700 dark:bg-night-900">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => setPreference(opt.value)}
          aria-pressed={preference === opt.value}
          title={opt.label}
          className={`rounded-md px-2 py-1 text-sm transition ${
            preference === opt.value
              ? "bg-brand-600 text-white"
              : "text-slate-500 hover:bg-slate-100 dark:text-night-400 dark:hover:bg-night-800"
          }`}
        >
          <span aria-hidden>{opt.icon}</span>
          <span className="sr-only">{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
